import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const BannerContainer = styled.div`
    background: linear-gradient(135deg, rgba(255, 107, 139, 0.15), rgba(107, 91, 255, 0.15));
    border: 1px solid rgba(255, 107, 139, 0.3);
    border-radius: 12px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    animation: ${slideDown} 0.3s ease-out;
`;

export const BannerContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
`;

export const BannerText = styled.span`
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.95rem;

    @media (max-width: 480px) {
        font-size: 0.85rem;
        text-align: center;
    }
`;

export const ClearButton = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    padding: 0.4rem 0.8rem;
    border-radius: 20px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.6);
    }

    &:active {
        transform: scale(0.98);
    }
`;
